import React, { Component } from "react";

import Input from "./Input";
import Form from "./Form";
import Select from "./Select";
import CheckBox from "./CheckBox";
const url =
  "https://www.skodalaagri.ee/sko/wp-content/themes/skodalaagri2017/rent/";

export default class FormSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cleared: false,
    };
  }

  componentDidMount() {}

  wasFormCleared = () => {
    this.setState((prevProps) => ({
      cleared: !prevProps.cleared,
    }));
  };

  toggleShowModal = () => {
    this.props.toggleShowModal();
  };

  setValues = (value) => {
    this.setState({
      selectedModels: value,
    });
  };

  render() {
    const { type } = this.state;
    return (
      <>
        <div className={`registration section`}>
          <div className="content" id="register">
            <img
              className="rent--logo"
              alt="Škoda laagri autorent"
              src={`${url}images/rendilogo.svg`}
            />

            <Form
              car={this.props.car}
              className={`form form-${type}`}
              submitText="REGISTREERU"
              type={type}
              wasFormCleared={() => this.wasFormCleared()}
            >
              <Input name="name" required className="half">
                Ees- ja perekonnanimi <span className="colorRed">*</span>
              </Input>

              <Input
                name="phone"
                pattern="[+\d+ ]{1,20}"
                required
                className="half"
              >
                Telefoni number <span className="colorRed">*</span>
              </Input>
              <Input type="email" name="email" required className="half">
                E-mail <span className="colorRed">*</span>
              </Input>

              {this?.props?.car?.make?.value === "skoda" &&
              this?.props?.tarvikud ? (
                <div className="extras">
                  {Object.keys(this.props.tarvikud).map((tarvik) => {
                    return (
                      <CheckBox
                        name={`cbs[${this.props.tarvikud[tarvik].vaartus}]`}
                        cleared={this.state.cleared}
                      >
                        <b>{this.props.tarvikud[tarvik].vaartus}</b> <br />
                        {this.props.tarvikud[tarvik].hind}.- EUR/päev
                      </CheckBox>
                    );
                  })}
                </div>
              ) : (
                ""
              )}

              <Input type="textarea" name="info" className="full">
                Sinu küsimused ja lisasoovid
              </Input>
              <CheckBox name="cb2" cleared={this.state.cleared}>
                Soovin saada Škoda uudiseid, infot ja pakkumisi.
              </CheckBox>
              <CheckBox name="cb1" required cleared={this.state.cleared}>
                Olen nõus isikuandmete kasutamisega{" "}
                <span className="colorRed">*</span>
              </CheckBox>

              <div className="submitButton">
                <Input className="button button--primaryInvert" type="submit">
                  SAADA
                </Input>
                <a
                  href="tel:6837080"
                  className="button button--primary button--icon"
                >
                  <img src={`${url}images/phone_glyphs.svg`} />
                  683 7080
                </a>
              </div>
              <p className="form--disclaimer">
                "Saada" nupu vajutamisega annate nõusoleku oma isikuandmete
                töötlemiseks teenusega seotud eesmärkidel kooskõlas{" "}
                <a
                  href="https://www.skodalaagri.ee/privaatsuspoliitika/"
                  target="_blank"
                  rel="noreferrer"
                >
                  privaatsuspoliitikaga.
                </a>
              </p>
            </Form>
          </div>
        </div>
      </>
    );
  }
}
